import React, { Component } from "react";
import { Link } from "react-router-dom";
//import simplWS_client from "./wsService";
import {
  getSystemLatestData,
  ws_getSystemLatestData,
  getSystemIntervalData,
  getSystemInfo,
  getSystemBasics,
  getSystemIDfromHandle,
  getSystem,
  ws_get,
  ws_post,
} from "../services/systemService";

import { setJwt, deleteHeaders } from "../services/httpService";
import { getUser } from "../services/userService";
import "./dashboard.css";
import "../index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ProgressBar from "react-bootstrap/ProgressBar";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-bootstrap/Modal";
import BackGroundRectangle from "../components/backgroundRect";

import CryptoJS from "crypto-js";

//const simplWS_client = new WebSocket("ws://127.0.0.1:8082");

class WebsocketComp extends Component {
  constructor(props) {
    super(props);
  }

  async componentDidMount() {
    /*const ipAddress = localStorage.getItem("ipAddress");
    console.log("IP Address: ", ipAddress);
    this.timerID = setInterval(() => this.tick(ipAddress), 1000);*/
  }

  /* componentWillUnmount() {
    clearInterval(this.timerID);
  }*/

  /* async getSystemData(ipAddress) {
    console.log("ESP32 Server IP Address: ", ipAddress);
    deleteHeaders();
    let getData = await ws_get(ipAddress);
    console.log("Get Data from ESP32 Server:", getData);
    const message = "stuff to be sent to the server...";
    let rcvd_data = await ws_post(ipAddress, message);
    console.log("Received data from ESP32 Server:", rcvd_data);
  }

  tick(ipAddress) {
    this.getSystemData(ipAddress);
  }*/

  fileHandler = (event) => {
    let fileObj = event.target.files[0];
    console.log("File Obj: ", fileObj);
    if (fileObj) {
      console.log("read the binary file");
      const reader = new FileReader();
      reader.readAsArrayBuffer(fileObj);
      console.log("Waiting for .onload");
      reader.onload = (e) => {
        console.log("Got .onload");
        const arrayBuffer = e.target.result;
        const uint8Array = new Uint8Array(arrayBuffer);
        console.log("Array: ", uint8Array);
        var hash = 0;
        const createPromise = new Promise((resolve, reject) => {
          resolve(crypto.subtle.digest("SHA-256", uint8Array));
        });

        createPromise.then((hash) => {
          const uint8ArrayHash = new Uint8Array(hash);

          let str = "";
          for (let i = 0; i < uint8ArrayHash.length; i++) {
            str += uint8ArrayHash[i].toString(16).toUpperCase();
          }
          console.log(str);
        });
      };
    }
  };

  render() {
    return (
      <div
        style={{
          width: "350",
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
          marginTop: "150px",
          marginBottom: "150px",
          zIndex: 1,
        }}
      >
        <p>In Websocket</p>

        <input
          type="file"
          onChange={this.fileHandler.bind(this)}
          className="inputTariff"
          style={{ padding: "10px" }}
        />
      </div>
    );
  }
}
export default WebsocketComp;
